
// Constant Data for Fast Sell Products

export const CATEGORY = {
  TAS       : 'tas',
  SEPATU    : 'sepatu',
  AKSESORIS : 'aksesoris'
}

export const CONDITION = {
  BRAND_NEW : 'brand_new',
  UNUSED    : 'unused',
  PERFECT   : 'perfect',
  EXCELLENT : 'excellent',
  USED      : 'used',
  VINTAGE   : 'vintage'
}

export const RECEIVED_STATUS = {
  PENDING  : 'pending',
  RECEIVED : 'received'
}

export const CURATION_STATUS = {
  PENDING  : 'pending',
  ACCEPTED : 'accepted',
  REJECTED : 'rejected'
}

export const REJECT_LABEL = {
  NO_DEMAND: {
    value : 'no_demand',
    label : 'Produk tidak sesuai daftar permintaan/pencarian pembeli.'
  },
  OUT_OF_PRICE_RANGE: {
    value : 'out_of_price_range',
    label : 'Melebihi batas harga jual putus.'
  },
  OUT_OF_CATEGORY: {
    value : 'out_of_category',
    label : 'Produk tidak sesuai daftar kategori permintaan/pencarian pembeli.'
  },
  OUT_OF_BRANDS: {
    value : 'out_of_brands',
    label : 'Produk tidak sesuai daftar brand yang diterima untuk Jual Putus.'
  },
  BAD_CONDITION: {
    value : 'bad_condition',
    label : 'Kondisi produk tidak memenuhi standar kurasi Jual Putus.'
  },
  PHOTO_INCOMPLETE: {
    value : 'photo_incomplete',
    label : 'Foto produk tidak lengkap.'
  },
  AUTHENTICITY_UNVERIFIABLE: {
    value : 'authenticity_unverifiable',
    label : 'Keaslian produk tidak dapat diverifikasi.'
  },
  NO_RESPONSE: {
    value : 'no_response',
    label : 'Penjual tidak merespon untuk informasi tambahan produk.'
  },
  DOUBLE_SUBMIT: {
    value : 'double_submit',
    label : 'Diajukan lebih dari satu kali.'
  },
  REQUEST_TO_RETURN: {
    value : 'request_to_return',
    label : 'Dibatalkan oleh penjual.'
  }
}

export const STATUS = {
  PENDING         : 'pending',
  PRICE_OFFER     : 'price_offer',
  SELLER_SHIPPING : 'seller_shipping',
  CURATION        : 'curation',
  VERIFICATION    : 'verification',
  FINANCE_PAYMENT : 'finance_payment',
  PURCHASED       : 'purchased',
  COMPLETED       : 'completed',
  REJECT          : 'reject',
  CANCELLED       : 'cancelled'
}

export const VERIFICATION_STATUS = {
  PENDING  : 'pending',
  ACCEPTED : 'accepted',
  REJECTED : 'rejected'
}

export const BRAND_CLASSIFICATION = {
  MALE                : 'Male',
  FEMALE              : 'Female',
  LUXURY              : 'Luxury',
  ASPIRATIONAL_LUXURY : 'Aspirational Luxury',
  HIGH_END_LUXURY     : 'High End Luxury'
}

export const IMAGE_ANGLE = {
  FRONT       : 'front',
  BACK        : 'back',
  LEFT        : 'left',
  RIGHT       : 'right',
  TOP         : 'top',
  UNDER       : 'under',
  INSIDE      : 'inside',
  LABEL       : 'label',
  SERIAL_CODE : 'serial_code',
  DEFECT      : 'defect',
  OTHERS      : 'others'
}

export const PER_PAGE = {
  5  : '5',
  10 : '10',
  25 : '25'
}

export const CONDITION_OPTIONS = [
  {
    id      : 1,
    value   : 'brand_new',
    label   : 'Brand New',
    details : [
      'Produk yang tidak pernah dipakai.' ,
      'Tidak ada kerusakan apapun.',
      'Disertai dengan tag/label pembelian yang asli.'
    ]
  },
  {
    id      : 2,
    value   : 'unused',
    label   : 'Unused',
    details : [
      'Produk yang tidak pernah dipakai.',
      'Tidak ada kerusakan apapun.'
    ]
  },
  {
    id      : 3,
    value   : 'perfect',
    label   : 'Perfect',
    details : [
      'Produk yang sudah dipakai dengan minimal sign of wear.',
      'Kondisi barang hampir seperti baru.'
    ]
  },
  {
    id      : 4,
    value   : 'excellent',
    label   : 'Excellent Condition',
    details : [
      'Produk yang sudah dipakai.',
      'Ada tanda bekas pemakaian yang wajar.'
    ]
  },
  {
    id      : 5,
    value   : 'used',
    label   : 'Used Condition',
    details : [
      'Produk yang sudah dipakai.',
      'Ada tanda bekas pemakaian yang signifikan seperti baret & kikis.'
    ]
  },
  {
    id      : 6,
    value   : 'vintage',
    label   : 'Vintage',
    details : [
      'Khusus Hermes & Chanel.'
    ]
  }
]

export const DETAIL_OPTIONS = [
  {
    id    : 1,
    value : 'box',
    label : 'Box'
  },
  {
    id    : 2,
    value : 'store_receipt',
    label : 'Store Receipt'
  },
  {
    id    : 3,
    value : 'authencity_card',
    label : 'Authencity Card'
  },
  {
    id    : 4,
    value : 'original_dustbag',
    label : 'Original Dustbag'
  },
  {
    id    : 5,
    value : 'care_card',
    label : 'Care Card'
  },
  {
    id    : 6,
    value : 'strap',
    label : 'Strap'
  },
  {
    id    : 7,
    value : 'paperbag',
    label : 'Paperbag'
  },
  {
    id    : 8,
    value : 'tag',
    label : 'Tag'
  },
  {
    id    : 9,
    value : 'raincoat',
    label : 'Raincoat'
  },
  {
    id    : 10,
    value : 'booklet',
    label : 'Booklet'
  },
  {
    id    : 11,
    value : 'flanel',
    label : 'Flanel'
  },
  {
    id    : 12,
    value : 'other',
    label : 'Lainnya'
  }
]


export const SORT_BY = {
  ID         : 'id',
  NAME       : 'name',
  CREATED_AT : 'created_at',
  UPDATED_AT : 'updated_at'
}

export const SORT_DIR = {
  ASC  : 'asc',
  DESC : 'desc'
}

export const DATA_TYPE = {
  ENDPOINT : 'endpoint',
  CONST    : 'const'
}

export const CATEGORY_OPTIONS = [
  {
    id        : 1,
    value     : 1,
    label     : 'Tas',
    is_leaf   : false,
    parent_id : 79
  },
  {
    id        : 79,
    value     : 79,
    label     : 'Wanita',
    is_leaf   : false,
    parent_id : null
  },
  {
    id        : 80,
    value     : 80,
    label     : 'Pria',
    is_leaf   : false,
    parent_id : null
  },
  {
    id        : 82,
    value     : 82,
    label     : 'Tas',
    is_leaf   : false,
    parent_id : 80
  },
  {
    id        : 2,
    value     : 2,
    label     : 'Backpack',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 3,
    value     : 3,
    label     : 'Clutch',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 4,
    value     : 4,
    label     : 'Handbag',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 5,
    value     : 5,
    label     : 'Luggage and Travel',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 6,
    value     : 6,
    label     : 'Pouch',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 7,
    value     : 7,
    label     : 'Satchel',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 8,
    value     : 8,
    label     : 'Sling Bag',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 9,
    value     : 9,
    label     : 'Shoulder Bag',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 10,
    value     : 10,
    label     : 'Tote Bag',
    is_leaf   : true,
    parent_id : 1
  },
  {
    id        : 101,
    value     : 101,
    label     : 'Backpack',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 102,
    value     : 102,
    label     : 'Clutch',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 103,
    value     : 103,
    label     : 'Handbag',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 104,
    value     : 104,
    label     : 'Luggage and Travel',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 105,
    value     : 105,
    label     : 'Pouch',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 106,
    value     : 106,
    label     : 'Satchel',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 107,
    value     : 107,
    label     : 'Sling Bag',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 108,
    value     : 108,
    label     : 'Shoulder Bag',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 109,
    value     : 109,
    label     : 'Tote Bag',
    is_leaf   : true,
    parent_id : 82
  },
  {
    id        : 110,
    value     : 110,
    label     : 'Briefcase',
    is_leaf   : true,
    parent_id : 82
  }
]
